import React from 'react';
import { Snackbar, Alert, AlertColor } from '@mui/material';

interface NotificationSystemProps {
  open: boolean;
  message: string;
  severity: AlertColor;
  onClose: () => void;
  autoHideDuration?: number;
}

const NotificationSystem: React.FC<NotificationSystemProps> = ({
  open,
  message,
  severity,
  onClose,
  autoHideDuration = 6000
}) => {
  return (
    <Snackbar
      open={open}
      autoHideDuration={autoHideDuration}
      onClose={onClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'right' }}
    >
      <Alert 
        onClose={onClose} 
        severity={severity}
        sx={{ 
          width: '100%',
          borderRadius: 2,
          boxShadow: '0px 10px 15px -3px rgba(0, 0, 0, 0.1), 0px 4px 6px -2px rgba(0, 0, 0, 0.05)',
          minWidth: 300,
          maxWidth: 500
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
};

export default NotificationSystem;
